import { useState } from 'react'
import { generateId, getRandomName, getRandomSentence } from '../utils/helper'

import userImage from "../assets/user.jpeg"

const createComment = (depth = 0, maxDepth = 3) => ({
  id: generateId(),
  name: getRandomName(),
  text: getRandomSentence(),
  replies: depth < maxDepth ? [createComment(depth + 1, maxDepth)] : [],
})

const generateComments = () => [
  createComment(0, 3),
  { id: generateId(), name: getRandomName(), text: getRandomSentence(), replies: [] },
  { id: generateId(), name: getRandomName(), text: getRandomSentence(), replies: [] },
]

const Comment = ({ info }) => {
  return (
    <div className="flex">
      <img className="h-12 w-12" alt="User avatar" src={userImage} />
      <div>
        <p className="font-semibold">{info.name}</p>
        <span>{info.text}</span>
      </div>
    </div>
  )
}

const CommentsList = ({ comments }) => {
  return (
    <>
      {comments.map(comment => {
        return (
          <div key={comment.id}>
            <Comment info={comment} />
            <div className="text-red-950 ml-4 border-l-2 border-solid border-black">
              <CommentsList
                comments={comment.replies}
              />
            </div>
          </div>
        )
      })}
    </>
  )
}

const CommentsContainer = () => {
  const [commentsData] = useState(() => generateComments())

  return (
    <div>
      <h1 className="font-bold">Comments</h1>
      <CommentsList comments={commentsData} />
    </div>
  )
}

export default CommentsContainer